export class SoQntDetail{
    finYear: string;
    finMonth:string;
    openSos: string;
    closesSos: string;
    cancelledSos: string;
    plant_code: string;
}